// @ts-ignore
/* eslint-disable */

import { request } from '@umijs/max';

export async function login(body: API.LoginBody, options?: { [key: string]: any }) {
  return request<API.LoginData>('/public-api/login-staff', {
    method: 'POST',
    data: body,
    ...(options || {}),
    // credentials: 'include',
  });
}

export async function getUser() {
  return request<any>(`/admin-api/staff-internal/info`, {
    method: 'GET',
  });
}

export async function refreshToken() {
  return request<API.RefreshTokenData>(`/v1/auth/refresh`, {
    method: 'POST',
  });
}

// export async function forgotPassword(
//   body: API.VerifyResetPasswordBody,
//   options?: { [key: string]: any },
// ) {
//   return request<any>(`/v1/auth/forgot-password`, {
//     method: 'POST',
//     data: body,
//     ...(options || {}),
//   });
// }
// export async function verifyResetPassword(
//   body: API.ForgotPasswordBody,
//   options?: { [key: string]: any },
// ) {
//   return request<any>(`/v1/auth/verify-reset-password`, {
//     method: 'POST',
//     data: body,
//     ...(options || {}),
//   });
// }

// export async function verifyLoginEmailCode(params: API.ParamsVerifyLoginEmailCode) {
//   return request<API.LoginData>(`/v1/auth/verify-login-email-code`, {
//     method: 'GET',
//     params,
//   });
// }

// export async function verifyLoginUsernameCode(params: API.ParamsVerifyLoginUsernameCode) {
//   return request<API.LoginData>(`/v1/auth/verify-login-username-code`, {
//     method: 'GET',
//     params,
//   });
// }

// export async function register(body: API.RegisterBody, options?: { [key: string]: any }) {
//   return request<any>(`/v1/auth/register`, {
//     method: 'POST',
//     data: body,
//     ...(options || {}),
//   });
// }

// export async function verifyRegisterCode(params: API.VerifyRegisterCodeParams) {
//   return request<any>(`/v1/auth/verify-register-code`, {
//     method: 'GET',
//     params,
//   });
// }

// export async function checkLogin(options?: { [key: string]: any }) {
//   return request<{
//     data?: {
//       data?: API.LoginData;
//     };
//   }>('/v1/tenants/auth/checkLogin', {
//     method: 'GET',
//     ...(options || {}),
//     // credentials: 'include',
//   });
// }

// export async function logout(options?: { [key: string]: any }) {
//   return request('/v1/tenants/auth/logout', {
//     method: 'DELETE',
//     ...(options || {}),
//     // credentials: 'include',
//   });
// }
